module.exports = __webpack_public_path__ + "img/hexagon.77f6febc.png";